import nativeAlert from './native-alert';

export default {
    nativeAlert
};